import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { getIsUnverified } from '../../publicSession/selectors';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { ArtBrandedMobilePopup } from '../../ArtBrandedPopup';
import Button from '../../Button';
import VerificationEmailInput from '../../VerificationEmailInput';
import s from './VerificationPopupMobile.scss';
var VerificationPopupMobile = function (_a) {
    var actionType = _a.actionType, email = _a.email, resendEmail = _a.resendEmail, onClose = _a.onClose;
    var t = useTranslation().t;
    var modalType = actionType ? 'action' : 'welcome';
    var isUnverified = useSelector(getIsUnverified);
    var title = t("verification.title.".concat(modalType), {
        action: t("verification.action.".concat(actionType)),
    });
    return (React.createElement(ArtBrandedMobilePopup, { artImageSrc: Url.staticCDNLink('eclipse/sisu/image-11-620625097.jpg'), artAuthorUsername: 'AxiomDesign', onClose: onClose, popupProps: { isOpen: true, forceTheme: ThemeOptions.DARK } },
        React.createElement("div", { className: s['content'] },
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['text'] }, t("verification.checkEmail.".concat(modalType), {
                postProcess: 'reactPostprocessor',
                email: React.createElement("span", { className: s['email'] }, email),
            })),
            React.createElement("div", { className: s['text'] }, t("verification.instructions.".concat(modalType))),
            React.createElement(Button, { className: s['resend-button'], view: "b3", fullWidth: false, onClick: function () {
                    resendEmail();
                    onClose && onClose();
                } }, t('verification.resend'))),
        React.createElement("div", { className: s['footer'] }, isUnverified ? (React.createElement("div", { className: s['footer-blurb'] },
            React.createElement(Trans, { i18nKey: "verification.doormatBlurb" },
                "If you don't recognize this email or no longer have access to it, please contact support at",
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: "mailto:accountrecovery@deviantart.com" }, "accountrecovery@deviantart.com"),
                " or",
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: "https://www.deviantartsupport.com/en/article/what-should-i-do-if-ive-lost-access-to-my-account" }, "learn more here"),
                "."))) : (React.createElement("div", { className: s['change-email'] },
            t('verification.notEmail', {
                postProcess: 'reactPostprocessor',
                email: React.createElement("span", { className: s['email'] }, email),
            }),
            React.createElement(VerificationEmailInput, { className: s['change-email-input'] }))))));
};
export default VerificationPopupMobile;
//# sourceMappingURL=VerificationPopupMobile.js.map